import React, { useState, useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import Alena from './img/Alena.png'
import AlenaPartnership from './img/AlenaPartnership.png'
import AlenaAds from './img/AlyonaAds.png'
import TrackPhoto from './img/cappuchino.webp'
import BGEqual from './img/bg_equal.png'
import BGEqualBig from './img/bg_equal_big.png'
import BGPartnership from './img/bg_partnership.png'
import TinkoffLogo from './img/tinkoff.png'
import BeautyBombLogo from './img/beautybomb.png'
import NikeLogo from './img/nike.png'
import FlightLogo from './img/flight.png'
import LevisLogo from './img/levis.png'
import ChupaChupsLogo from './img/chupa-chups.png'
import video from '../../video/video4.mov'

import Pic1 from './img/bous.jpg'
import Pic2 from './img/avi.jpg'
import Pic3 from './img/spi.jpg'
import Pic4 from './img/vecno.jpg'
import Pic5 from './img/gerda.jpg'

export const Page = () => {
  const [textColor, setTextColor] = useState("text-white");
  const [track, setTrack] = useState({})
  const fetchTrack = async () => {
    try {
      const response = await fetch("https://api.alyonatestsite.store/api/settings");
      if (!response.ok) {
        throw new Error("Ошибка загрузки данных");
      }
      const data = await response.json();
      setTrack(data.track);
    } catch (err) {
    }
  }
  useEffect(() => {
    fetchTrack();
  }, []);
  // useEffect(() => {
  //   const getAverageBrightness = (image) => {
  //     const canvas = document.createElement("canvas");
  //     const ctx = canvas.getContext("2d");
  //     canvas.width = image.width;
  //     canvas.height = image.height;
  //     ctx.drawImage(image, 0, 0, canvas.width, canvas.height);
  //     const data = ctx.getImageData(0, 0, canvas.width, canvas.height).data;
  //     let totalBrightness = 0, count = 0;
  //     for (let i = 0; i < data.length; i += 40) {
  //       const r = data[i];
  //       const g = data[i + 1];
  //       const b = data[i + 2];
  //       const brightness = (r * 0.299 + g * 0.587 + b * 0.114);
  //       totalBrightness += brightness;
  //       count++;
  //     }
  //     const avgBrightness = totalBrightness / count;
  //     setTextColor(avgBrightness > 127 ? "text-black" : "text-white");
  //   };
  //   const img = new Image();
  //   img.src = `https://api.alyonatestsite.store${track.preview}`;
  //   img.crossOrigin = "Anonymous";
  //   img.onload = () => getAverageBrightness(img);
  // }, []);
  useEffect(() => {
    AOS.init({
      duration: 1000,
      disable: window.innerWidth < 768 ? 'mobile' : false,
    });
    const handleResize = () => {
      const leftElements = document.querySelectorAll('[data-aos="fade-left"]');
      const rightElements = document.querySelectorAll('[data-aos="fade-right"]');
      if (window.innerWidth < 768) {
        leftElements.forEach(el => el.setAttribute('data-aos', 'fade-up'));
        rightElements.forEach(el => el.setAttribute('data-aos', 'fade-up'));
      } else {
        leftElements.forEach(el => el.setAttribute('data-aos', 'fade-left'));
        rightElements.forEach(el => el.setAttribute('data-aos', 'fade-right'));
      }
    };
    window.addEventListener('resize', handleResize);
    handleResize();
    return () => window.removeEventListener('resize', handleResize);
  }, []);
  return (
    <section
      id="main"
      className="w-full flex flex-col justify-center items-center"
    >
      <div className="w-full flex flex-col items-center justify-center">
         <a className="w-full h-screen relative bg-black"
         href="/concerts">

  <img
    src="https://api.alyonatestsite.store/uploads/lol333.png"
    alt=""
    className="absolute top-0 left-0 w-full h-full object-cover block lg:hidden"
  />


  <img
    src="https://api.alyonatestsite.store/uploads/lol222.png"
    alt=""
    className="absolute top-0 left-0 w-full h-full object-cover hidden lg:block"
  />

  <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 hidden lg:flex font-lack m-0 p-0 flex-col items-center justify-center text-center space-y-1">
    {/* <p className="lg:text-[75px] xl:text-[100px] text-white">алёна швец.</p> */}
  </div>
</a>
        {/* <div className="absolute bottom-0 left-0 w-full h-64 bg-gradient-to-t from-black via-black/80 to-transparent"></div> */}


        <div className="relative w-full min-h-screen lg:min-h-0 lg:h-[600px] overflow-hidden text-white">
  <div
    className="absolute inset-0 bg-center bg-cover brightness-[0.2] scale-110"
    style={{
      backgroundImage: `url(https://api.alyonatestsite.store${track.preview})`,
    }}
  ></div>

  <div className="relative z-10 flex flex-col items-center justify-center min-h-screen lg:min-h-0 lg:h-[600px] px-4 text-center">
    <img
      src={`https://api.alyonatestsite.store${track.preview}`}
      alt="track"
      className="w-40 h-40 sm:w-56 sm:h-56 md:w-64 md:h-64 lg:w-80 lg:h-80 object-cover rounded-md shadow-lg"
    />
    <h1 className="mt-6 text-3xl sm:text-4xl md:text-5xl font-lack">{track.name}</h1>
    <p className="mt-2 text-base sm:text-lg md:text-xl font-lack text-white text-opacity-70">алёна швец.</p>
    <button
      className="mt-6 sm:mt-8 bg-white text-black font-lack px-6 sm:px-10 py-2 rounded-lg hover:bg-gray-200 transition"
      onClick={() => window.location.href = track.link}
    >
      {track.button}
    </button>
  </div>
</div>


        <div className="bg-[#fdfff6] flex items-center justify-center w-full">
          <div className="py-16 flex flex-col w-full items-center justify-center">
            <div className="flex flex-col items-center justify-center">
              <p className="text-[17px] lg:text-[22px] text-center font-lack px-6 md:px-8 lg:px-0 lg:w-1/2"
                data-aos="fade-up">
                Я безумно рада приветствовать вас на моём официальном сайте! С 2017 года моя музыка не покидает ваших плейлистов, выпущено более сотни треков, сыграно множество концертов в каждом уголке страны, а песни на стримингах собирают более 5 миллионов прослушиваний ежемесячно
              </p>
            </div>
            <img
              src={Alena}
              alt="bg"
              className="w-[740px] h-[740px] object-contain"
              data-aos="fade-up"
            />
          </div>
        </div>
        <div className="z-30 mt-[-500px] lg:mt-[-300px] flex items-center justify-center w-full h-[600px]">
          <img
            src={BGEqual}
            alt="bg"
            className="w-full h-[500px] lg:h-auto object-cover 4xl:hidden"
          />
          <img
            src={BGEqualBig}
            alt="bg"
            className="w-full h-[500px] lg:h-auto object-cover hidden 4xl:flex"
          />
          <div className="absolute flex items-center justify-center w-full h-full">
            <h1 data-aos="fade-up"
              className="font-crooker text-center w-3/4 2xl:max-w-[1450px] text-[18px] lg:text-[28px] xl:text-[32px] 2xl:text-[35px] text-white">В 2021 году Spotify разместил билборд со мной на Таймс-сквер в Нью-Йорке в рамках своей программы по поддержке женщин в музыкальной индустрии — Equal.
              В этом же году я стала самой прослушиваемой певицей по версии Spotify в России, обогнав Билли Айлиш и Ариану Гранде</h1>
          </div>
        </div>
        <div className="z-10 mt-[-100px] lg:mt-[-50px] 4xl:mt-[-150px] py-12 xl:py-20 bg-gradient-to-r from-violet-400 to-fuchsia-300 flex items-center justify-center w-full">
          <div className="mt-16 xl:mt-40 flex flex-col items-center justify-center space-y-12 w-full h-full">
            <h1 data-aos="fade-up"
              className="font-crooker text-center w-3/4 text-[30px] xl:text-[45px] 2xl:text-[55px] text-white">
              Более 400 млн прослушиваний
            </h1>
            <div className="flex flex-col xl:flex-col justify-center items-center w-full space-x-0 xl:space-x-12 space-y-12 xl:space-y-0">
              <div data-aos="fade-up" className="flex flex-col items-center w-full">
<div className="relative rounded-xl w-3/4 h-[200px] lg:w-[550px] lg:h-[250px] xl:w-[600px] xl:h-[300px] mb-4">
    {/* Размытое свечение */}
    <div
      className="absolute inset-0 rounded-xl bg-cover bg-center filter blur-xl opacity-70 animate-pulseBlur"
      style={{
        backgroundImage: `url(${Pic1})`
      }}
    ></div>
    {/* Основная картинка */}
    <div
      className="absolute inset-0 rounded-xl bg-cover bg-center"
      style={{
        backgroundImage: `url(${Pic1})`
      }}
    ></div>
  </div>

  <div className="relative bg-sky-700 rounded-xl flex items-center justify-center font-crooker text-lg text-white px-4 py-[2px] overflow-hidden">
    <span className="relative z-10">Новый клип</span>
    <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/50 to-transparent -translate-x-full animate-[shine_2s_linear_infinite]" />
  </div>

  <h1 className="font-lack text-white text-[30px] mb-2">«Боюсь, но хочу»</h1>
  <a
    className="py-2 px-12 bg-white rounded-xl font-lack text-[16px] cursor-pointer"
    href="https://vkvideo.ru/video-163226140_456240868"
    target="_blank"
    rel="noreferrer"
  >
    Смотреть в VK Видео
  </a>
</div>


            </div>
            <div className="flex flex-col w-full space-y-12">
              <div className="flex flex-col xl:flex-row justify-center w-full xl:space-x-12 space-y-12 xl:space-y-0">
                <div data-aos="fade-right"
                  className="flex flex-col items-center">
                  <div className="rounded-xl w-3/4 h-[200px] lg:w-[550px] lg:h-[250px] xl:w-[600px] xl:h-[300px] bg-black mb-4"
                    style={{
                      backgroundImage: `url(${Pic2})`,
                      backgroundSize: "cover",
                      backgroundPosition: "center",
                    }}></div>
                  <h1 className="font-lack text-white text-[30px] mb-2">«А вы с ней снова?»</h1>
                  <a className="py-2 px-12 bg-white rounded-xl font-lack text-[16px] cursor-pointer"
                    href="https://vkvideo.ru/playlist/-163226140_-2/video-163226140_456240661?t=8s"
                    target="_blank"
                    rel="noreferrer">
                    Смотреть в VK Видео
                  </a>
                </div>
                <div data-aos="fade-left"
                  className="flex flex-col items-center">
                  <div className="rounded-xl w-3/4 h-[200px] lg:w-[550px] lg:h-[250px] xl:w-[600px] xl:h-[300px] bg-black mb-4"
                    style={{
                      backgroundImage: `url(${Pic3})`,
                      backgroundSize: "cover",
                      backgroundPosition: "center",
                    }}></div>
                  <h1 className="font-lack text-white text-[30px] mb-2">«Спи»</h1>
                  <a className="py-2 px-12 bg-white rounded-xl font-lack text-[16px] cursor-pointer"
                    rel="noreferrer"
                    href="https://vkvideo.ru/video-163226140_456240406"
                    target="_blank">
                    Смотреть в VK Видео
                  </a>
                </div>
              </div>
              <div className="flex flex-col xl:flex-row justify-center w-full xl:space-x-12 space-y-12 xl:space-y-0">
                <div data-aos="fade-right"
                  className="flex flex-col items-center">
                  <div className="rounded-xl w-3/4 h-[170px] lg:w-[550px] lg:h-[250px] xl:w-[600px] xl:h-[300px] bg-black mb-4"
                    style={{
                      backgroundImage: `url(${Pic4})`,
                      backgroundSize: "cover",
                      backgroundPosition: "center",
                    }}></div>
                  <h1 className="font-lack text-white text-[30px] mb-2">«Вечно 17»</h1>
                  <a className="py-2 px-12 bg-white rounded-xl font-lack text-[16px] cursor-pointer"
                    href="https://vkvideo.ru/video-163226140_456240383"
                    rel="noreferrer"
                    target="_blank">
                    Смотреть в VK Видео
                  </a>
                </div>
                <div data-aos="fade-left"
                  className="flex flex-col items-center">
                  <div className="rounded-xl w-3/4 h-[170px] lg:w-[550px] lg:h-[250px] xl:w-[600px] xl:h-[300px] bg-black mb-4"
                    style={{
                      backgroundImage: `url(${Pic5})`,
                      backgroundSize: "cover",
                      backgroundPosition: "center",
                    }}></div>
                  <h1 className="font-lack text-white text-[30px] mb-2">«Герда»</h1>
                  <a className="py-2 px-12 bg-white rounded-xl font-lack text-[16px] cursor-pointer"
                    href="https://vkvideo.ru/video-163226140_456240262"
                    rel="noreferrer"
                    target="_blank">
                    Смотреть в VK Видео
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="z-20 relative flex items-center justify-center w-full mt-[-50px] xl:mt-0">
          <img
            src={BGPartnership}
            alt="Background"
            className="absolute w-full h-full object-cover"
          />
          <div className="relative flex flex-col xl:flex-row w-full max-w-screen-xl mx-auto px-4 lg:px-0">
            { }
            <div className="flex flex-col justify-center w-full xl:w-1/2 px-4 py-16 space-y-12">
              <h1 data-aos="fade-up"
                className="font-crooker text-3xl sm:text-4xl xl:text-6xl text-white text-center xl:text-left">
                Сотрудничество
              </h1>
              <div data-aos="fade-right"
                className="grid grid-cols-2 sm:grid-cols-3 gap-6 justify-center items-center text-center">
                <img
                  src={TinkoffLogo}
                  alt="Tinkoff"
                  className="h-20 sm:h-28 object-contain mx-auto"
                />
                <img
                  src={BeautyBombLogo}
                  alt="Beauty Bomb"
                  className="h-20 sm:h-28 object-contain mx-auto"
                />
                <img
                  src={NikeLogo}
                  alt="Nike"
                  className="h-20 sm:h-28 object-contain mx-auto"
                />
                <img
                  src={FlightLogo}
                  alt="Flight"
                  className="h-20 sm:h-28 object-contain mx-auto"
                />
                <img
                  src={LevisLogo}
                  alt="Levis"
                  className="h-20 sm:h-28 object-contain mx-auto"
                />
                <img
                  src={ChupaChupsLogo}
                  alt="Chupa Chups"
                  className="h-20 sm:h-28 object-contain mx-auto"
                />
              </div>
            </div>
            { }
            <div data-aos="fade-up"
              className="flex justify-end items-center w-full xl:w-1/2">
              <img
                src={AlenaPartnership}
                alt="Alena Partnership"
                className="w-full h-auto max-h-[500px] object-contain"
              />
            </div>
          </div>
        </div>
        <div className="z-20 relative flex items-center justify-center w-full bg-gradient-to-r from-[#FB7F56] to-red-600">
          <div className="relative flex flex-col xl:flex-row-reverse w-full max-w-screen-xl mx-auto px-4 lg:px-0">
            { }
            <div data-aos="fade-left"
              className="flex flex-col justify-center items-center xl:items-end w-full xl:w-1/2 px-4 py-8">
              <h1 className="font-crooker text-3xl sm:text-4xl xl:text-6xl text-white text-center xl:text-right">
                Рекламные возможности
              </h1>
              <p className="mt-12 font-lack text-xl text-white text-center xl:text-right w-4/5">
                Нативная интеграция бренда при стоимости от 30 копеек за 1 просмотр
              </p>
              <p className="mt-3 font-lack text-xl text-white text-center xl:text-right w-4/5">
                Более 6,3 млн охвата в социальных сетях
              </p>
            </div>
            { }
            <div data-aos="fade-up"
              className="flex justify-end items-center w-full xl:w-1/2">
              <img
                src={AlenaAds}
                alt="AlenaAds"
                className="w-full h-auto max-h-[500px] object-contain"
              />
            </div>
          </div>
        </div>
        <div className="z-20 relative flex items-center justify-center w-full bg-gradient-to-r from-[#F385FF] to-[#AA33FF] xl:py-16">
          <div className="relative flex flex-col xl:flex-row w-full max-w-screen-xl mx-auto px-4 lg:px-0">
            { }
            <div data-aos="fade-right"
              className="flex flex-col justify-end items-center xl:items-start w-full xl:w-1/2 px-4 py-8 xl:py-0">
              <h1 className="font-crooker text-3xl sm:text-4xl xl:text-6xl text-white text-center xl:text-left">
                Сотрудничество с Алёной
              </h1>
              <p className="mt-4 font-lack text-xl text-white text-center xl:text-left">
                alyonacooperation@gmail.com
              </p>
            </div>
            <div data-aos="fade-left"
              className="flex flex-col justify-end items-center xl:items-end w-full xl:w-1/2 px-4 py-8 xl:py-0">
              <h1 className="font-crooker text-3xl sm:text-4xl xl:text-6xl text-white text-center xl:text-right">
                Организация концертов
              </h1>
              <p className="mt-4 font-lack text-xl text-white text-center xl:text-right">
                alyonashvets.concert@gmail.com
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
